import percentChanged from "../../../../../components/percentChanged/percentChanged";
import {connect} from "react-redux";

export default connect(state => ({
  changeValue: state.funnelChart.funnelChartData.funnel_laser.enrollment / state.funnelChart.funnelChartData.funnel_laser.lead,
  toolTip: "Percentage of leads converted to enrollment",
  showBorder: true,
  hideChange: true
}))(percentChanged);
